export default "__VITE_ASSET__DU8tPqHR__"